// Группы клиентов. Личная — клиенты платят сами, у каждого свой счёт. Коммерческий проект — за своих клиентов
// платит организация, счёт у группы общий. У каждого клиента и у каждой сессии — своя группа (по номеру).
export const GROUP_KIND = { PERSONAL: 'personal', PROJECT: 'project' } as const;
export type GroupKind = typeof GROUP_KIND[keyof typeof GROUP_KIND];

export const GROUP_KIND_LABEL: Readonly<Record<GroupKind, string>> = { personal: 'личная', project: 'проект' };

export interface GroupLike { id: string; kind: GroupKind }

export function isCommercial(g: { kind: GroupKind } | null | undefined): boolean {
  return !!g && g.kind === GROUP_KIND.PROJECT;
}

// Кто платит за сессию: коммерческий проект — сам проект (его номер), личная группа — клиент.
export function payerOf(session: { clientId: string; groupId: string },
  groups: ReadonlyMap<string, GroupLike>): string {
  const g = groups.get(session.groupId);
  return g && g.kind === GROUP_KIND.PROJECT ? g.id : session.clientId;
}

export function mapById<T extends { id: string }>(list: readonly T[]): Map<string, T> {
  return new Map(list.map((x) => [x.id, x]));
}
